<div class="flujo-validacion-panel">
    <p-messages *ngIf="validando" [value]="[{ severity: 'info', summary: 'Validando...', detail: 'Consultando al servidor' }]" [enableService]="false" [closable]="false"></p-messages>

    <p-messages *ngIf="muestraExito" severity="success" [value]="[{ severity: 'success', summary: 'Flujo válido', detail: 'No se encontraron violaciones estructurales.' }]" [enableService]="false" [closable]="false"></p-messages>

    <p-messages *ngIf="!validando && valido === false" [value]="mensajes" [enableService]="false" [closable]="false"></p-messages>
</div>
